module.exports = __webpack_public_path__ + "static/img/active.35ca851b.png";